import { NodeType } from '../../node/types';
import { DEFAULT_LOCATION as loc } from '../../source/location';

export const createStringLiteral = (value: string) => ({
  type: NodeType.StringLiteral,
  loc,
  value,
  original: value,
});
